import DOMPurify from 'dompurify';

/**
 * Shared DOMPurify rules for TipTap HTML (descriptions, rich comments).
 * Do not allow `style` or `class` — use global CSS (see index.scss).
 */
export const SANITIZE_RICH_HTML_CONFIG = {
  ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 's', 'a', 'span'],
  ALLOWED_ATTR: [
    'href',
    'target',
    'rel',
    'data-type',
    'data-id',
    'data-label',
    'data-mention-handle',
  ],
};

/**
 * Minimal tags from legacy plain-text linkification (@mentions, URLs, newlines).
 */
export const SANITIZE_LEGACY_INLINE_CONFIG = {
  ALLOWED_TAGS: ['a', 'br', 'p', 'strong', 'em', 's', 'span'],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'data-mention-handle'],
};

export function sanitizeRichHtml(html) {
  return DOMPurify.sanitize(html, SANITIZE_RICH_HTML_CONFIG);
}

export function sanitizeLegacyInlineHtml(html) {
  return DOMPurify.sanitize(html, SANITIZE_LEGACY_INLINE_CONFIG);
}

/** Wrapper class for scoped rules (e.g. external link underline) in index.scss */
export const USER_CONTENT_RICH_CLASS = 'user-content-rich';
